(function () {

	'use strict';

	/*global $:true, cologic:true */

	// "Quote Slider" content element (CType "quote_slider", QuoteSlider.fluid.html): an
	// endless iosSlider like cologic.initStdSlider (same #sliderContainer-N /
	// #sliderButtonContainer-N / #sliderArrowContainer-N contract and fade callbacks), but
	// auto-advancing every 8 s and pausing while hovered. Quote lengths differ, so the slider
	// height comes from the tallest quote card via cologic.initCrawlerSliderHeight
	// (cologic-crawlerControls.js) - iosSlider alone would collapse it to 0px.

	let cologicQuoteSlider = {

		initQuoteSlider: function (rootSelector, elemNr) {
			let $root = $(rootSelector);
			let sliderId = '#sliderContainer-' + elemNr;
			if ($root.length <= 0 || $(sliderId).length <= 0) return;

			$(sliderId).iosSlider({
				snapToChildren: true,
				scrollbar: false,
				scrollbarHide: true,
				desktopClickDrag: true,
				autoSlide: true,
				autoSlideTimer: 8000,
				autoSlideTransTimer: 1000,
				autoSlideHoverPause: true,
				startAtSlide: 1,
				navSlideSelector: $('#sliderButtonContainer-' + elemNr + ' .sliderButton'),
				navPrevSelector: $('#sliderArrowContainer-' + elemNr + ' .prev'),
				navNextSelector: $('#sliderArrowContainer-' + elemNr + ' .next'),
				onSlideChange: cologic.someCallback,
				onSlideStart: cologic.fadeSliderOut,
				onSlideComplete: cologic.fadeSliderIn,
				infiniteSlider: true,
				responsiveSlideContainer: true,
				responsiveSlides: true,
				onSliderResize: cologic.sliderUpdate
			});

			cologic.initCrawlerSliderHeight($root, {slider: '.slider', card: '.quote-card'});
		}

	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicQuoteSlider);
}());
